import { render, staticRenderFns } from "./MFooter.vue?vue&type=template&id=2a8767e9&scoped=true&"
import script from "./MFooter.vue?vue&type=script&lang=js&"
export * from "./MFooter.vue?vue&type=script&lang=js&"
import style0 from "./MFooter.vue?vue&type=style&index=0&id=2a8767e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8767e9",
  null
  
)

export default component.exports